import { useState } from 'react';
import { useBusiness } from '../../../contexts/BusinessContext';
import { TicketPreview } from '../../sales/components/TicketPreview';
import { PrintTicketButton } from '../../sales/components/PrintTicketButton';

/**
 * Componente para configurar los templates de tickets
 */
export function TicketTemplateSettings() {
  const { business } = useBusiness();
  const [selectedType, setSelectedType] = useState('delivery');
  
  // Datos de ejemplo para la vista previa
  const sampleSale = {
    id: 'sample-123',
    display_id: '1234',
    status: 'completed',
    total_amount: 125.00,
    total_deposit_amount: 15.00,
    customer_name: 'Cliente de Ejemplo',
    payment_method: 'Efectivo',
    payment_reference: 'REF-123',
    notes: 'Entregar en la puerta principal',
    items: [
      {
        id: 'item-1',
        title: 'Café Americano',
        quantity: 2,
        unit_price: 45.00
      },
      {
        id: 'item-2',
        title: 'Croissant',
        quantity: 1,
        unit_price: 35.00
      }
    ]
  };

  return (
    <div className="bg-white rounded-lg shadow-sm p-6">
      <h2 className="text-2xl font-bold mb-6">Configuración de Tickets</h2>
      
      <div className="mb-6">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Tipo de Ticket
        </label>
        <div className="flex space-x-4">
          <button
            onClick={() => setSelectedType('delivery')}
            className={`px-4 py-2 rounded-md ${
              selectedType === 'delivery'
                ? 'bg-blue-500 text-white'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }`}
          >
            Entrega
          </button>
          <button
            onClick={() => setSelectedType('fulfillment')}
            className={`px-4 py-2 rounded-md ${
              selectedType === 'fulfillment'
                ? 'bg-blue-500 text-white'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }`}
          >
            Preparación
          </button>
          <button
            onClick={() => setSelectedType('backup')}
            className={`px-4 py-2 rounded-md ${
              selectedType === 'backup'
                ? 'bg-blue-500 text-white'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }`}
          >
            Respaldo
          </button>
        </div>
      </div>
      
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div>
          <h3 className="text-lg font-medium mb-4">Vista Previa</h3>
          <TicketPreview
            sale={sampleSale}
            type={selectedType}
            className="mb-4"
          />
          <div className="mt-4">
            <PrintTicketButton
              sale={sampleSale}
              type={selectedType}
              label={`Imprimir prueba de ${
                selectedType === 'delivery' ? 'entrega' :
                selectedType === 'fulfillment' ? 'preparación' : 'respaldo'
              }`}
            />
          </div>
        </div>
        
        <div>
          <h3 className="text-lg font-medium mb-4">Información del Ticket</h3>
          <div className="bg-white border border-gray-200 rounded-md p-4">
            <p className="text-sm text-gray-600 mb-4">
              Los tickets se generan automáticamente con la información de la venta.
              Cada tipo de ticket tiene un propósito específico:
            </p>
            
            <ul className="list-disc pl-5 space-y-2 text-sm text-gray-600">
              <li>
                <strong>Ticket de Entrega:</strong> Se entrega al cliente como comprobante de la venta.
                Incluye detalles de productos, precios y totales.
              </li>
              <li>
                <strong>Ticket de Preparación:</strong> Para uso interno, muestra solo los productos y cantidades
                para facilitar la preparación del pedido.
              </li>
              <li>
                <strong>Ticket de Respaldo:</strong> Copia completa para el negocio, incluye toda la información
                de la venta, incluyendo método de pago.
              </li>
            </ul>
            
            <div className="mt-6 p-3 bg-blue-50 rounded-md">
              <p className="text-sm text-blue-700">
                <strong>Nota:</strong> Los tickets se imprimen en formato de texto plano optimizado para
                impresoras térmicas de 80mm. El sistema utiliza templates estructurados para generar
                el contenido de manera consistente.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
} 